'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAWellFormedAddress = exports.mapDelta = exports.distanceBetweenPoints = exports.formatResult = exports.addressFromCoordinates = exports.coordinatesFromAddress = exports.mergeAddresses = exports.extractAddressComponent = exports.validateStreetNumber = exports.deliveryAddressFactory = exports.addressComponentsToString = exports.formatAddressDescription = exports.S_NUMBER_RGX = exports.GEO_COMPONENTS = exports.setApiKey = exports.getApiKey = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* global fetch */


var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var API_KEY; // eslint-disable-line
var getApiKey = exports.getApiKey = function getApiKey() {
  return API_KEY;
};
var setApiKey = exports.setApiKey = function setApiKey(apiKey) {
  API_KEY = apiKey;
};

var GEO_COMPONENTS = exports.GEO_COMPONENTS = {
  STREET: 'route',
  STREET_NUMBER: 'street_number',
  ZIP: 'postal_code',
  CITY_GEO: 'locality',
  CITY_GEO_ALT: 'administrative_area_level_3',
  CITY: 'city',
  COUNTRY: 'country'
};

var DISTANCE_THRESHOLD = 50;

var S_NUMBER_RGX = exports.S_NUMBER_RGX = /[0-9]{1,6}[,/-]?[a-zA-Z]?/;

var getApiUrl = function getApiUrl(reverse) {
  if (reverse) {
    return 'https://maps.googleapis.com/maps/api/geocode/json?latlng=XXX__LAT,XXX__LNG&key=' + getApiKey(); // REVERSE
  }
  return 'https://maps.googleapis.com/maps/api/geocode/json?address=[XXX__ADDRESS]&key=' + getApiKey(); // REGULAR
};

var formatAddressShort = function formatAddressShort(components) {
  return [components[GEO_COMPONENTS.STREET], components[GEO_COMPONENTS.CITY]].join(', ');
};

var formatAddressDescription = exports.formatAddressDescription = function formatAddressDescription(components) {
  var shortForm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (typeof components === 'string') {
    return components;
  }

  if (shortForm) {
    return formatAddressShort(components);
  }

  var filter = void 0;
  if (components[GEO_COMPONENTS.STREET_NUMBER]) {
    filter = [components[GEO_COMPONENTS.STREET], components[GEO_COMPONENTS.STREET_NUMBER], components[GEO_COMPONENTS.CITY]];
  } else {
    filter = [components[GEO_COMPONENTS.STREET], components[GEO_COMPONENTS.CITY]];
  }
  return filter.join(', ');
};

var addressComponentsToString = exports.addressComponentsToString = function addressComponentsToString(components) {
  var streetNumber = components[GEO_COMPONENTS.STREET_NUMBER] || '';
  var zipCode = components[GEO_COMPONENTS.ZIP] || '';
  return [components[GEO_COMPONENTS.STREET], streetNumber, zipCode, components[GEO_COMPONENTS.CITY], components[GEO_COMPONENTS.COUNTRY]].join(', ');
};

var deliveryAddressFactory = exports.deliveryAddressFactory = function deliveryAddressFactory(description, lat, lng, addressComponents) {
  return {
    description: description,
    addressComponents: addressComponents,
    geometry: {
      location: { lat: lat, lng: lng }
    }
  };
};

var validateStreetNumber = exports.validateStreetNumber = function validateStreetNumber(number) {
  return S_NUMBER_RGX.test(number);
};

var extractAddressComponent = exports.extractAddressComponent = function extractAddressComponent(components) {
  return _lodash2.default.reduce(components, function (f, c) {
    var filtered = Object.assign({}, f);
    if (c.types[0] === GEO_COMPONENTS.STREET || c.types[0] === GEO_COMPONENTS.STREET_NUMBER || c.types[0] === GEO_COMPONENTS.ZIP || c.types[0] === GEO_COMPONENTS.COUNTRY) {
      filtered[c.types[0]] = c.long_name;
    }
    // a cleaner and more human name for city
    if (c.types[0] === GEO_COMPONENTS.CITY_GEO) {
      filtered.city = c.long_name;
    }

    // keep administrative_area_3 as city if locality is not available
    if (c.types[0] === GEO_COMPONENTS.CITY_GEO_ALT && !filtered.city) {
      filtered.city = c.long_name;
    }

    return filtered;
  }, {});
};

var mergeAddresses = exports.mergeAddresses = function mergeAddresses(currentAddress, newAddress) {
  var currentAddrSNum = currentAddress[GEO_COMPONENTS.STREET_NUMBER];
  if (!currentAddrSNum) {
    return _extends({}, newAddress);
  }
  var newAddrSNum = newAddress[GEO_COMPONENTS.STREET_NUMBER];

  // keep user street number even if google did not
  // get it
  if (currentAddrSNum && !newAddrSNum) {
    return _extends({}, newAddress, _defineProperty({}, GEO_COMPONENTS.STREET_NUMBER, currentAddrSNum));
  }

  // use currentAddress if is a substring of newAddress or if is "valid",
  // e.g. 56/A and 56
  var streetNumber = currentAddrSNum.indexOf(newAddrSNum) >= 0 || validateStreetNumber(currentAddrSNum) ? currentAddrSNum : newAddrSNum;

  return _extends({}, newAddress, _defineProperty({}, GEO_COMPONENTS.STREET_NUMBER, streetNumber));
};

var coordinatesFromAddress = exports.coordinatesFromAddress = function coordinatesFromAddress(address) {
  var API_URL = getApiUrl();
  var reqURL = API_URL.replace('XXX__ADDRESS', encodeURI(address));

  return fetch(reqURL).then(function (res) {
    return res.json();
  }).then(function (res) {
    var data = res.results[0];
    var components = extractAddressComponent(data.address_components);
    return {
      data: {
        address: {
          components: components,
          location: {
            description: formatAddressDescription(components),
            geometry: {
              location: data.geometry.location
            }
          }
        }
      }
    };
  }).catch(function (e) {
    console.log(e); // eslint-disable-line
    return { errors: [{ message: _i18next2.default.t('user.address_s_number_error') }] };
  });
};

var addressFromCoordinates = exports.addressFromCoordinates = function addressFromCoordinates(lat, lng) {
  var REVERSE_API_URL = getApiUrl(true);
  var reqURL = REVERSE_API_URL.replace('XXX__LAT', lat).replace('XXX__LNG', lng);

  return fetch(reqURL).then(function (res) {
    return res.json();
  }).then(function (res) {
    if (!res.results.length) {
      throw new Error('No results');
    }

    var data = res.results[0];
    var components = extractAddressComponent(data.address_components);
    return {
      data: {
        address: {
          components: components,
          location: {
            description: formatAddressDescription(components),
            geometry: {
              location: data.geometry.location
            }
          }
        }
      }
    };
  }).catch(function (e) {
    console.log(e); // eslint-disable-line
    return { errors: [{ message: _i18next2.default.t('user.address_s_number_error') }] };
  });
};

var formatResult = exports.formatResult = function formatResult(details) {
  var _details$geometry$loc = details.geometry.location,
      lat = _details$geometry$loc.lat,
      lng = _details$geometry$loc.lng;
  // extract needed components

  var addressComponents = extractAddressComponent(details.address_components);
  var description = formatAddressDescription(addressComponents);
  return deliveryAddressFactory(description, lat, lng, addressComponents);
};

var R = 6371000; // earth's radius in meters
var degreesToRadians = function degreesToRadians(g) {
  return g * Math.PI / 180;
};
/*
 * distance between 2 points {lat:xxx, lng:yyy}
*/
var distanceBetweenPoints = exports.distanceBetweenPoints = function distanceBetweenPoints(p1, p2) {
  var l1 = degreesToRadians(p1.lat);
  var l2 = degreesToRadians(p2.lat);
  var dphi = degreesToRadians(p2.lat - p1.lat);
  var dalp = degreesToRadians(p2.lng - p1.lng);

  // https://en.wikipedia.org/wiki/Haversine_formula
  var haversine = Math.sin(dphi / 2) * Math.sin(dphi / 2) + Math.cos(l1) * Math.cos(l2) * Math.sin(dalp / 2) * Math.sin(dalp / 2);

  // anuglar distance in radius
  var c = 2 * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));

  // distance in km and m
  var d = Math.ceil(R * c);
  return Number((d / 1000).toFixed(2));
};

var mapDelta = exports.mapDelta = function mapDelta(p1, p2) {
  var distance = distanceBetweenPoints(p1, p2);
  if (distance === 0) {
    return 0.045;
  }

  return distance / 90;
};

var isAWellFormedAddress = exports.isAWellFormedAddress = function isAWellFormedAddress(addressComponents) {
  return addressComponents.filter(function (comp) {
    return comp.types.indexOf(GEO_COMPONENTS.STREET) > -1;
  }).length > 0;
};

exports.default = {
  DISTANCE_THRESHOLD: DISTANCE_THRESHOLD,
  GEO_COMPONENTS: GEO_COMPONENTS,
  S_NUMBER_RGX: S_NUMBER_RGX,
  getApiKey: getApiKey,
  setApiKey: setApiKey,
  extractAddressComponent: extractAddressComponent,
  formatAddressDescription: formatAddressDescription,
  coordinatesFromAddress: coordinatesFromAddress,
  addressFromCoordinates: addressFromCoordinates,
  distanceBetweenPoints: distanceBetweenPoints,
  mapDelta: mapDelta,
  deliveryAddressFactory: deliveryAddressFactory,
  formatResult: formatResult,
  addressComponentsToString: addressComponentsToString,
  isAWellFormedAddress: isAWellFormedAddress,
  validateStreetNumber: validateStreetNumber,
  mergeAddresses: mergeAddresses
};


//////////////////
// WEBPACK FOOTER
// ./~/@arreeba/ristoranti-frontend-lib/lib/helpers/location.js
// module id = 50
// module chunks = 0